import { ApiService, EntityBuildableInterface } from '@kaiser-software/chassis-core';
import { ObservationModel } from '../models/observation.model';

export class ObservationService extends ApiService implements EntityBuildableInterface {

    public restEndpoint = 'observations';

    public entityName = 'observation';

    public model = ObservationModel;

    public allWhereStatusIsOpen() {
        return this.allWith(
            false,
            [
                'location',
                'category',
                'category.category',
            ],
            {
                search: 'status:open',
                include: 'user',
                orderBy: 'created_at',
                sortedBy: 'desc',
            }
        );
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/observations/services/observation.service.ts